// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Cvzi","input":"styles_input__1B0IG"};